import { Component, Input } from '@angular/core';

@Component({
    selector: 'reqentcriteria',
    templateUrl: 'reqentcriteria.component.html',
    styleUrls: ['reqentcriteria.component.scss'],
})
export class ReqEntCriteriaComponent{
  @Input() public enteteData;

  constructor() {

  }

  public ngOnInit() {

  }

  public ngOnChanges() {

  }

}


